import { t } from "@lingui/core/macro";
import { isPresent } from "./checks";
import { Currency } from "./localization/currency";
import { formatI18nCurrency } from "./localization/formatCurrency";
import { AvailableWebPrice } from "@silversea-ssc/dotcom-api-types/Prices";
import { match } from "ts-pattern";

export const formatPrice = (
  price: AvailableWebPrice | undefined,
  currency: Currency | undefined
): string | undefined => {
  if (!isPresent(price)) return undefined;
  return match(price)
    .with({ type: "waitlist" }, () => getWaitlistLabel())
    .with({ type: "price" }, (price) =>
      formatI18nCurrency(price.amount, currency)
    )
    .with({ type: "discounted" }, (price) =>
      formatI18nCurrency(price.amount, currency)
    )
    .exhaustive();
};

export const getWaitlistLabel = () =>
  t({
    id: "waitlist-price",
    message: "WAITLIST"
  });
